import { render, staticRenderFns } from "./FileUploader.vue?vue&type=template&id=31e8dc24&scoped=true&"
import script from "./FileUploader.vue?vue&type=script&lang=js&"
export * from "./FileUploader.vue?vue&type=script&lang=js&"
import style0 from "./FileUploader.vue?vue&type=style&index=0&id=31e8dc24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e8dc24",
  null
  
)

export default component.exports